export const SERVER_URL = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:10011/';

export const PAIDIT_API = SERVER_URL + 'website/';

export const TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Asia/Jerusalem';

export const PIZZA_COVERS = ['◉', '◑', '◐'];
